.plan-description {
  grid-row: var(--lineup-plan-grid-row-description);
  color: var(--gray-637381);
}
